import Image from 'next/image';

import { KeyValueRow, KeyValueTable, Text } from '@/design-system/components/ui';

import { Trigger } from '../../domain';
import { AddressChip } from './components/AddressChip';

interface Props {
  trigger: Trigger;
}

export const AquariusTriggerFullDetails = ({ trigger }: Props) => {
  const poolAddress = trigger.context?.pool_address ?? '';

  const poolDisplay = (
    <div className="tw:flex tw:flex-row tw:gap-2 tw:items-center">
      <AddressChip
        address={poolAddress}
        scannerUrl={`https://stellar.expert/explorer/public/contract/${poolAddress}`}
        hideChainIcon
      />
    </div>
  );

  const networkDisplay = (
    <div className="tw:flex tw:flex-row tw:items-center tw:gap-2">
      <Image src="/assets/webp/stellar.webp" alt="Stellar" width={20} height={20} />
      <span>Stellar</span>
    </div>
  );

  // The pool's two tokens are not stored on the trigger — one position emits an event per leg and
  // the currency travels with each one, so there is no single trigger-level currency to show.
  const currencyDisplay = (
    <Text variant="body-sm" color="muted">
      The pool&apos;s own two tokens, one per position leg
    </Text>
  );

  return (
    <KeyValueTable>
      <KeyValueRow label="Name" value={trigger.name} />
      <KeyValueRow label="Description" value={trigger.description} />
      <KeyValueRow label="Executed with" value="Snapshots of Aquarius liquidity positions in pool">
        {poolAddress ? (
          <div className="tw:flex tw:flex-row tw:gap-1 tw:items-center tw:flex-wrap tw:ml-2">{poolDisplay}</div>
        ) : null}
      </KeyValueRow>
      <KeyValueRow label="Network" value={networkDisplay} />
      <KeyValueRow label="Volume currency" value={currencyDisplay} />
      <KeyValueRow label="Argument conditions" value={trigger.conditionExpression ?? '-'} />
    </KeyValueTable>
  );
};
